const edsURL = `${import.meta.env.VUE_APP_EDS_SERVER}:${443}`

const team = 'live_plus'

const isEDSEnabled = import.meta.env.PROD && import.meta.env.VUE_APP_EDS_SERVER && import.meta.env.VUE_APP_EDS_KEY

export const logEvent = async (event_name, user, event_json = {}) => {
	const event = {
		api_key: import.meta.env.VUE_APP_EDS_KEY,
		event_type: team + '_events',
		data: {
			event_name,
			team,
			...user,
			event_json: {...event_json, url: location.href},
		},
	}

	// Add UTM query parameters separately to payload, if present.
	if (location.search) {
		const whitelistedParams = ['utm_campaign', 'utm_content', 'utm_keyword', 'utm_medium', 'utm_source', 'utm_term']
		const paramsIterator = new URLSearchParams(location.search)
		paramsIterator?.forEach((paramValue, paramKey) => {
			if (whitelistedParams.includes(paramKey)) {
				if (!event.data.event_json) event.data.event_json = {}
				event.data.event_json[paramKey] = paramValue
			}
		})
	}

	if (!isEDSEnabled) {
		return 'EDS is not enabled'
	}

	return await fetch(edsURL + '/send_event', {
		method: 'POST',
		body: JSON.stringify(event),
		headers: {
			'Content-Type': 'application/json',
		},
	})
}
